module.exports = __webpack_public_path__ + "static/media/MJ.6067f50a.jpg";